<template>
  <div class="series-module" v-if="list.length">
    <h2 class="title">{{ t('common.supportModule') }}</h2>
    <div v-if="redesign" class="module-grid">
      <a
        v-for="(item, index) in flatModules"
        :key="`${item.name}-${index}`"
        class="module-tile"
        :href="item.link || undefined"
      >
        <img v-lazy="item.url" :alt="item.name" />
        <span>{{ item.name }}</span>
      </a>
    </div>
    <div v-else class="module-content">
      <a-carousel arrows autoplay>
        <div class="module-item" v-for="(item, index) in list" :key="index">
          <div
            :class="{
              'item-border': true,
              'even-item-border': item.length % 2 == 0,
              'odd-item-border': item.length === 1,
            }"
          >
            <div v-for="el in item" :key="el.name" class="item">
              <div class="img-wrapper" @click="handleClick(el.link)">
                <img v-lazy="el.url" :class="{ spec: el.spec }" />
              </div>
              <p class="name">{{ el.name }}</p>
            </div>
          </div>
        </div>
      </a-carousel>
    </div>
  </div>

  <QuecQi v-if="list.length" />
</template>

<script setup>
import { onMounted, ref, inject, watch, computed } from 'vue'
import { useRoute } from 'vue-router'
import QuecQi from '@/components/QuecQi.vue'
import { useI18n } from 'vue-i18n'

const route = useRoute()
const { t } = useI18n()

const list = ref([])
const detailData = inject('detailData', null)
const redesign = inject('algorithmDetailRedesign', false)
const flatModules = computed(() => list.value.flat().filter(Boolean))

const handleClick = (link) => {
  location.href = link
}

onMounted(() => {
  handleActiveList()
})

watch(
  () => detailData?.value?.introduce?.chips_info,
  (chipsInfo) => {
    if (chipsInfo) {
      handleActiveList()
    }
  },
  { deep: true },
)

const handleActiveList = () => {
  // 优先使用 chips_info 中的数据
  if (detailData?.value?.introduce?.chips_info) {
    list.value = detailData.value.introduce.chips_info
  }
}
</script>

<style lang="scss" scoped>
.series-module {
  background-color: #fff;

  .title {
    height: 42px;
    text-align: center;
    padding-top: 96px;
    padding-bottom: 70px;
    font-size: 30px;
    font-weight: 500;
    color: #272727;
  }

  .module-content {
    max-width: 1170px;
    margin: auto;
    padding-bottom: 120px;

    .module-item {
      position: relative;
      display: inline-block;

      .item-border {
        flex: 1;
        display: flex;
        justify-content: space-between;
      }

      .even-item-border,
      .odd-item-border {
        justify-content: space-evenly;
      }

      .item {
        display: flex;
        justify-content: center;
        flex-direction: column;
        width: 370px;
        height: 308px;

        .img-wrapper {
          width: 100%;
          display: flex;
          justify-content: center;
          background-color: #e9ecec;
          overflow: hidden;
          position: relative;
          cursor: pointer;
          &::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            transition: all 1.3s cubic-bezier(0.4, 0, 0.2, 1);
            -webkit-transition: all 1.3s cubic-bezier(0.4, 0, 0.2, 1);
            background-image: linear-gradient(to top, #000000bf, #0000 55%);
          }
        }

        &:hover .img-wrapper::after {
          opacity: 0;
          transition-duration: 0.6s;
        }

        &:hover img {
          transform: scale(1.1);
        }
      }

      img {
        box-sizing: border-box;
        height: 236px;
        object-fit: fill;
        cursor: pointer;
        transition-duration: 0.6s;
        background-color: #e9ecec;
      }

      .spec {
        height: 236px;
      }

      .name {
        height: 28px;
        color: #000;
        font-size: 22px;
        font-weight: 400;
        text-align: left;
        margin-top: 42px;
      }
    }
  }
}

:deep(.slick-slide) {
  text-align: center;
  height: 348px;
  // background-color: #e9ecec;
  overflow: hidden;
}

:deep(.slick-arrow.custom-slick-arrow) {
  width: 25px;
  height: 25px;
  font-size: 25px;
  color: #386cf9;
  // background-color: #e9ecec;
  transition: ease all 0.3s;
  opacity: 0.8;
  z-index: 1;
}
:deep(.slick-arrow.custom-slick-arrow:before) {
  display: none;
}
:deep(.slick-arrow.custom-slick-arrow:hover) {
  color: #94aef4;
}

// :deep(.ant-carousel .slick-dots-bottom) {
//   bottom: -10px;
// }

:deep(.ant-carousel .slick-dots li.slick-active button) {
  background: #484848;
}
:deep(.ant-carousel .slick-dots li button) {
  background: #c8c8c8;
}
:deep(.ant-carousel .slick-dots-bottom) {
  bottom: 1px;
}
</style>
